import type { EHR_PROVIDERS } from "@/frontend/constants/ehr-providers";
import type { BackendConfig } from "@/server/schema/admin";

export type SavedRow = { id: string; provider_type: string; client_id: string | null; has_secret?: boolean; disabled_at: Date | string | null; updated_at: Date | string };
/** Saved practitioner clinical-workflow config row — `SavedRow` plus the app launch URL, CDS endpoint, and the effective (custom-or-managed) client ID in use. */
export type ClinicalWorkflowRow = SavedRow & { app_launch_url: string | null; cds_endpoint: string | null; cds_caching_enabled: boolean; client_id_in_use: string | null };
export type Provider = typeof EHR_PROVIDERS[number];
export const CREDENTIAL_MODE = {
  MEDBLOCKS: "medblocks",
  OWN: "own",
} as const;

export type CredentialMode = typeof CREDENTIAL_MODE[keyof typeof CREDENTIAL_MODE];

/** Full backend (SMART Backend Services) config as returned by `admin.getBackend`. */
export type BackendData = BackendConfig;
/** A Group ID staged locally (no server id — reconciled by value on save). */
export type LocalGroup = { group_id: string; label: string | null };
/** A backend source staged locally in the editor. */
export type LocalSource = { fhir_source: string; name: string | null; logo: string | null; groups: LocalGroup[] };
